import React from "react";
import FormikTextField from "../fields/FormikTextField";

const PersonalDataStep = () => (
  <div className="step">
    <h3 className="main_question">
      <strong>1/4</strong>Datos personales
    </h3>
    <FormikTextField
      name="name"
      label="Nombre completo"
      placeholder="Escribe tu nombre completo"
      autoComplete="name"
      autoFocus
      required
    />
    <FormikTextField
      name="email"
      type="email"
      label="Correo electrónico"
      placeholder="Escribe tu correo electrónico"
      autoComplete="email"
      required
    />
    <FormikTextField
      name="phone"
      type="tel"
      label="Teléfono"
      placeholder="+569 87654321"
      autoComplete="tel"
      inputMode="tel"
      required
    />
  </div>
);

export default PersonalDataStep;
